import React, {Fragment} from "react";
import HeaderLeftSide from "./HeaderLeftSide";
import HeaderRightSide from "./HeaderRightSide";

const Header = props => {

    return (
        <Fragment>
            <header className={`header-${props.header ? props.header : 'normal' }`}>
                <HeaderLeftSide title={props.title} header={props.header}/>
                <HeaderRightSide onThemeChange={props.onThemeChange}/>
            </header>
        </Fragment>
    );
};

export default Header;